import FieldWrapper from './FieldWrapper';
import RenderFilterFieldByType from '@buildwise/libs/feed/components/RenderFilterFieldByType';
import { ConfigEntryType } from 'config/config';
import { useFormContext } from 'react-hook-form';
import { EditProfileFormSchema } from '../../hooks/useProfileForm';
import { Box, Typography } from '@mui/material';
import { theme } from 'config/theme';
import InformationLineIcon from 'remixicon-react/InformationLineIcon';
type ProfileCustomFieldsProps = {
  fields: ConfigEntryType[];
};

function ProfileCustomFields({ fields }: ProfileCustomFieldsProps) {
  const {
    formState: { isSubmitting },
  } = useFormContext<EditProfileFormSchema>();

  return (
    <>
      {fields.map((field) => (
        <FieldWrapper
          id={field.entryCode}
          label={field.referenceObject?.label || field.entryDescription}
          required={field.referenceObject?.isRequired}
          disabled={isSubmitting}
        >
          <RenderFilterFieldByType field={field} />
          {['region', 'department'].includes(field.entryCode) && (
            <Box
              sx={{
                mt: 0.5,
                display: 'flex',
                alignItems: 'center',
                color: theme.palette.custom.mistBlue,
              }}
            >
              <InformationLineIcon size={16} />
              <Typography
                sx={{
                  fontSize: 13,
                  fontWeight: 400,
                  ml: 0.5,
                }}
              >
                Your notifications will be curated based on your selection.
              </Typography>
            </Box>
          )}
        </FieldWrapper>
      ))}
    </>
  );
}

export default ProfileCustomFields;
